<template>
  <f7-page name="event-details">
    <f7-navbar title="Event Details" back-link="Back">
      <f7-nav-right>
        <f7-link  href="/" class="menu-icon"><i class="az-icon-home-house-interface-ui-website"></i></f7-link>
      </f7-nav-right>
    </f7-navbar>


    <!-- <f7-block-title>Event Details</f7-block-title> -->

    <!-- Event Header -->
    <f7-row>
        <div class="col-40 col-sm-0">
          <div class="left-az-logo">
            <img src="../assets/images/left-logo.png" alt="" />
          </div>
        </div>
        <div class="col-60 col-sm-100">
          <div v-if="event" style="margin-top: 20px; margin-right: 40px">
              <div v-if="event.photo && event.photo != 'public/'" class="event-banner" style="height: auto; background: transparent">
                <img style="width: 100%" :src="$root.siteURL + event.photo.replace('public', 'storage')">
              </div>
              <!-- Event Header -->
              <div class="event-header purpleBg">
                <h2 class="event-tilte">{{ event.title }}</h2>
                <div class="event-location-title"><i class="fa fa-map-marker" aria-hidden="true"></i> {{ event.venue }}, {{ event.location }}</div>
                <div class="event-date"><i class="fa fa-calendar" aria-hidden="true"></i> {{ formateDate(event) }}</div>
                <div class="event-attend-num" v-if="attendeesCount > 0"><i class="fa fa-users" aria-hidden="true"></i> {{ attendeesCount }} attendees</div>
              </div>

              <!-- Event Content -->
              <div class="event-content ">

                <div class="quiz-button" v-if="quizes.length">
                  <a class="button button-fill block" href="#" v-for="quiz in quizes" :key="quiz.id" v-if="quiz.user_took_quiz[0].answered <= 0" @click="goToQuiz(quiz)">Take the Quiz</a>
                </div>

                <h3 class="text-center">About Conference</h3>
                <div class="event-content-details text-center" v-html="event.event_description"></div>
                <div class="event-content-details text-center" v-if="event.zoom_link">
                  <p><strong><a :href="event.zoom_link" class="external">Open Zoom Link</a></strong></p>
                </div>
                <div v-if="showFeedback()">
                  <p>
                    <a class="button button-fill block" href="/feedback/">Rate the event</a>
                  </p>
                </div>
                <div class="speaker" @click="showSpeaker(speaker)" v-if="speakers.length" v-for="speaker in speakers" :key="speaker.id">
                  <f7-row>
                    <f7-col width="30">
                      <div class="speaker-image">
                        <img :src="$root.siteURL + speaker.photo.replace('public', 'storage')" v-if="speaker.photo">
                      </div>
                    </f7-col>
                    <f7-col width="70">
                      <div class="speaker-details">
                        <div class="speaker-details-content">
                          <span><strong>Speaker: </strong> {{ speaker.name }}, </span>
                          <span>{{ speaker.title }}</span>
                        </div>
                      </div>
                    </f7-col>
                  </f7-row>
                </div>
                <!-- Event Location Map -->
                <div class="event-location-map" v-html="event.map_location" v-if="event.map_location">
                </div>
              </div>

              <!--  <br>
                <f7-button v-if="(user_type == 'astrazeneca_medical') || (user_type == 'astrazeneca_marketing') || (user_type == 'astrazeneca_sales')" @click="scan();">Scan</f7-button> -->
              <br>

              <!-- Event Action -->
              <div class="event-action">
                <p class="segmented segmented-raised">
                  <a href="#" :class="{ 'button': true, 'purpleBg': true, 'disabled': isUserInvited == 1}" @click.prevent="setInvitationStatus(1)">
                    <span :class="{'bold-text': isUserInvited == 1}">Accept</span>
                  </a>

                  <f7-button fill raised popup-open="#my-Feedback" :class="{ 'button': true, 'yellowBg': true, 'disabled': isUserInvited == 3}" @click.prevent="setInvitationStatus(3)">Maybe</f7-button>

                  <button :class="{ 'button': true, 'redBg': true, 'disabled': isUserInvited == 2}" @click.prevent="setInvitationStatus(2)">Decline</button>
                </p>
              </div>
          </div>
        </div>
    </f7-row>

    <div class="popup popup-speaker" style="overflow: scroll;">
      <f7-navbar title="Event Details">
        <f7-nav-right>
          <f7-link  @click="closeSpeaker"  href="#" class="menu-icon"><i class="az-icon-delete-remove-close-cancel"></i></f7-link>
        </f7-nav-right>
      </f7-navbar>
      <!-- <f7-navbar> -->
        <!-- <div style="padding: 5px 10px; text-align: right">
          <f7-link  @click="closeSpeaker"  href="#" class="menu-icon"><i class="az-icon-delete-remove-close-cancel"></i></f7-link>
        </div> -->
      <!-- </f7-navbar> -->

      <div class="block" v-if="currenSpeaker">
        <div style="text-align: center">
          <img v-if="currenSpeaker.photo"  style="width: 250px; border-radius: 150px;" :src="$root.siteURL + currenSpeaker.photo.replace('public', 'storage')">
          <h1>{{ currenSpeaker.name }}</h1>
          <h5>{{ currenSpeaker.title }}</h5>
        </div>

        <div  style="text-align: left" v-html="currenSpeaker.bio"></div>

        <div v-if="showFeedbackForm" class="speaker-feedback" style="text-align: center; padding-top: 15px;">
          <h3>Send Your Feedback About Speaker</h3>
          <div class="feedback-rate">
            <div class="rating">
              <star-rating v-model="speaker_rating"></star-rating>
            </div>
          </div>

          <div class="feedback-button">
            <div class="row">
              <f7-col width="100">
                <a @click="saveSpeakerFeedback" href="#" class="button button-fill button-round">Send Feedback</a>
              </f7-col>
            </div>
          </div>
        </div>

      </div>
    </div>
  </f7-page>
</template>
<script>
import StarRating from 'vue-star-rating'
export default {
  components: {
    StarRating
  },
  data() {
    return {
      event: null,
      user_type: '',
      isUserInvited: '',
      speakers: [],
      attendeesCount: 0,
      months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
      quizes: [],
      currenSpeaker: '',
      speaker_rating: 0,
      showFeedbackForm: true
    }
  },
  methods: {
  
      scan:function() {
        var _this = this;
            window.cordova.plugins.barcodeScanner.scan(
                    function(result){
                        console.log(result);
                        if(!result.cancelled){
                            if(result.format == "QR_CODE") {
                                console.log(result.format);
                                var value = result.text;

                                      //alert('Your Code Is '+value);
                                      _this.$f7.preloader.show()
                                      _this.$http.post( _this.$root.apiBaseURL + 'change-attend-status/' + _this.event.id + '/' + value + '/' + 1 )
                                        .then( (res) => {
                                          _this.$f7.dialog.alert( res.data.message, 'Thank you' )
                                          _this.$f7.preloader.hide()
                                        } )
                                        .catch( (error) => {
                                          console.log(error)
                                          _this.$f7.preloader.hide()
                                  })

                            }
                        }
                },
                function (error) {
                    console.log(error);
                    alert('Scanning Failed '+error);
                }
           );
      },
    saveSpeakerFeedback: function() {
      this.$f7.preloader.show()

      var data = {
        rating: this.speaker_rating,
        speaker_id: this.currenSpeaker.id
      }

      this.$http.post( this.$root.apiBaseURL + 'save-speaker-feedback', data )
        .then( (res) => {
          this.$f7.preloader.hide()
          this.$f7.dialog.alert('Thank you for your feedback', 'Thanks')
          localStorage.setItem('feed_back_speaker_' + this.currenSpeaker.id, 'yes')
          this.$f7.popup.close('.popup-speaker')
          this.speaker_rating = 0
        })
        .catch( (err) => {
          this.$f7.preloader.hide()
          console.log( err )
        })

    },
    showSpeaker: function(speaker) {
      this.currenSpeaker = speaker
      this.$f7.popup.open('.popup-speaker')
      if( localStorage.getItem('feed_back_speaker_' + this.currenSpeaker.id) ) {
        this.showFeedbackForm = false
      } else {
        this.showFeedbackForm = true
      }
    },
    closeSpeaker: function(){
      this.$f7.popup.close('.popup-speaker')
    },
    goToQuiz: function(quiz) {
      sessionStorage.setItem('currentQuiz', JSON.stringify(quiz))
      this.$f7.view.current.router.navigate('/quiz/')
    },
    setInvitationStatus: function(status) {
      if(this.isUserInvited == status) {
        return false
      }

      this.$f7.preloader.show()
      this.$http.post( this.$root.apiBaseURL + 'change-invitation-status/' + this.event.id + '/' + status )
        .then( (res) => {
          this.$f7.dialog.alert( res.data.message, 'Thank you' )
          this.isUserInvited = status
          this.$f7.preloader.hide()
        } )
        .catch( (error) => {
          console.log(error)
          this.$f7.preloader.hide()
        })
    },
    formatAMPM(date) {
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var ampm = hours >= 12 ? 'pm' : 'am';
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      minutes = minutes < 10 ? '0'+minutes : minutes;
      var strTime = hours + ':' + minutes + ' ' + ampm;
      return strTime;
    },
    formateDate: function(event) {
      var d = new Date(event.event_time.replace(/-/g, "/"))
      console.log(d.getFullYear());
      return d.getDate() + ' ' + this.months[d.getMonth()] + '  '+ d.getFullYear() + ' ' + this.formatAMPM(new Date(event.event_time.replace(/-/g, "/")))
    },
    showFeedback: function() {
      if(this.event.event_time) {
        var d = new Date(new Date())
        // var dat = d.getDate() + ' ' + this.months[d.getMonth()] + ' ' + this.formatAMPM( d )
        var mon = "0" + (parseInt(d.getMonth()) + 1)
        mon = mon.slice(-2)
        var day = "0" + d.getDate()
        day = day.slice(-2)
        var min = "0" + d.getMinutes()
        min = min.slice(-2)
        var sec = "0" + d.getSeconds()
        sec = sec.slice(-2)
        var dat = d.getFullYear() + '-' + mon + '-' + day + ' ' + d.getHours() + ':' + min + ':' + sec
        return dat >= this.event.event_time
      }
    }
  },
  mounted: function() {

    const url = window.location.href;
    const lastParam = url.split("/").slice(-1)[0];
    console.log(lastParam);

    var data_user = JSON.parse(localStorage.getItem('loggedUser'))

    this.user_type = data_user.user_type;

    // this.event = JSON.parse(sessionStorage.getItem('currentEvent'))
// console.log(this.$f7.view.current.router.currentRoute.params.event_id)
// debugger
    this.$f7.preloader.show()
    setTimeout(() => {
      var event_id = this.$f7.view.current.router.currentRoute.params.event_id;
      this.$http.get( this.$root.apiBaseURL + 'get-event-data/' +  event_id)
      .then( (res) => {
        // invitation (status = 0 => no action) - (status = 1 => accepted) - (status = 2 => rejected) - (status = 3 => maybe)
        this.event = res.data.event
        this.isUserInvited = res.data.invitation ? res.data.invitation.status : ''
        this.speakers = res.data.speakers
        this.attendeesCount = res.data.attendees_count
        this.quizes = res.data.quizes
        this.$f7.preloader.hide()
      } )
    }, 1000);

  }
}
</script>



<style scoped>
  .menu-icon i::before {
    color: #870047;
    font-size: 35px;
  }
  .bold-text {
    /*font-weight: bold;
    text-decoration: underline;*/
  }
  .active-status {
    background: #008706 !important
  }
</style>
